import {
  EMarketingCenterFormats,
  IMarketingCenterFormat
} from '@/models/marketingCenter/format';
import { ICanvasElement } from '@/models/marketingCenter/canvas';

class FacebookPostFormat implements IMarketingCenterFormat {
  constructor(elements: ICanvasElement[]) {
    this.elements = elements;
  }

  key = EMarketingCenterFormats.facebookPost;
  name = 'Facebook Post';
  elements: ICanvasElement[];
  canvas = {
    width: 251,
    height: 131
  };
  asset = {
    width: 1200,
    height: 630
  };
  share = {
    width: 105,
    height: 54,
    icon: 'facebook'
  };
}

export default FacebookPostFormat;
